// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1a-8P","checkboxCol":"Table_checkboxCol__3OsHh","emailCol":"Table_emailCol__2Lwpj","actionCol":"Table_actionCol__1N_xg"};